<template>
  <v-container fluid grid-list-xl>
    <v-layout row wrap>
      <v-flex xs12>
        <h1>
          {{ $tc('models.overweight') }}
        </h1>
      </v-flex>

      <v-flex xs12>
        <CustomerOverweightList v-if="$auth.isCust()" :canRebate="canRebate"></CustomerOverweightList>
        <OverweightList v-else :canRebate="canRebate"></OverweightList>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Setting from '@/client/setting'

import CustomerOverweightList from '@/components/overweights/CustomerOverweightListComp'
import OverweightList from '@/components/overweights/OverweightListComp'

export default {
  name: 'Overweight',

  props: {},

  data () {
    return {
      overweightSetting: false,
      canRebate: false,
    }
  },

  components: {
    CustomerOverweightList,
    OverweightList,
  },

  computed: {
  },

  methods: {
    async fetchSetting () {
      try {
        const overweightSetting = await Setting.byKey('overweights')
        this.overweightSetting = overweightSetting.value === '1'

        const overweightRebateSetting = await Setting.byKey('overweights_request_rebate')
        this.canRebate = overweightRebateSetting.value === '1'
      } catch (e) {
        this.handleErr(e)
      }
    },
  },

  watch: {
  },

  async mounted () {
    await this.fetchSetting()
    if (!this.$auth.isDev() && !this.overweightSetting) {
      this.goTo('dashboard')
    }
  }
}
</script>
